import React from "react";

import bg from '../../assets/header/Search-sticky-background-v2.png';
import logo from '../../assets/header/CL_Logo_White+Lemon_Horizontal.png';

export default function Login() {
  return (
    <div style={{
      minHeight: '100vh',
      minWidth: '100vw',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1000
    }}>
      <div style={{
        width: 360,
        borderRadius: 18,
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '40px 32px 32px 32px',
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
        <div style={{
          width: 320,
          height: 160,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 32
        }}>
          <img src={logo} alt="Creative Library Logo" style={{ width: 200, borderRadius: 12 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
          <button
            // onClick={() => { window.location.href = 'http://localhost:8080/LoginOkta'; }} //dev
            onClick={() => { window.location.href = '/LoginOkta'; }}
            style={{
              padding: '10px 0',
              background: '#2c3e50',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              fontSize: 15,
              fontWeight: 400,
              cursor: 'pointer',
              marginBottom: 6,
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
            }}
          >
            Login with Okta
          </button>
        </div>
      </div>
    </div>
  );
}